import { useState, useEffect, React } from "react";
import * as FaIcons from "react-icons/fa";
import { Button, Modal, Container, Row, Col, FormControl, FormLabel } from 'react-bootstrap';
import JobsList from './JobsList';
import JobDataService from './services/job.service';

function SearchJob(props) { 
  const [lgShow, setLgShow] = useState(false);
  const [jobtitle,setJobtitle] = useState('');
  const [sorttype, setSorttype] = useState('ASC');
  const [sortfield, setSortfield] = useState('id');
  const [listOfJobs, setListOfJobs] = useState([]);

  const handleClose = () => setLgShow(false);

  const handleShow = () => {
    setLgShow(true);            
  }

  const onChangeSortType = () => {
    setSorttype(sorttype == 'DESC'?'ASC':'DESC');
    performSearch(jobtitle,sortfield,sorttype);    
  }

  const onChangeSortField = (e) => {
    setSortfield(e.target.value);
    performSearch(jobtitle,e.target.value,sorttype);
  }

  const onChangeJobFilterByDescr = (e) => {
    setJobtitle(e.target.value)
    performSearch(e.target.value,sortfield,sorttype);
  }  

  const performSearch = (descr,sortf,sortt) => {
    JobDataService.getJobByDescr(descr,sortf,sortt)
      .then(response => {
        console.log(response.data);
        setListOfJobs(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {performSearch(jobtitle,sortfield,sorttype)},[]);

    return (
      <>
        <Button className='ms-2' lg={8} style={{maxWidth:"50px",maxHeight:'38px'}} variant="primary" onClick={handleShow} disabled={props.disabled}><FaIcons.FaSearch /></Button>      
        <Modal
          size="lg"
          show={lgShow}
          onHide={() => setLgShow(false)}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {'Select Job'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row className='mb-2 d-flex'>
                <Col lg={true}>
                  <FormLabel className='mb-2'>Filter by Job Title:</FormLabel>       
                  <FormControl type="text" name="filterbyjobtitle" id="filterbyjobtitle" onChange={onChangeJobFilterByDescr}></FormControl>
                </Col>
                <Col lg={true}>
                  <FormLabel className='mb-2'>Sort By:</FormLabel>       
                    <FormControl as='select' onChange={onChangeSortField}>
                      <option value="id">Job ID</option>
                      <option value="jobtitle">Job Title</option>
                    </FormControl>
                </Col>
                
                <Col sm={true}>
                  <FormLabel className='mb-2'>Asc/Desc:</FormLabel>       
                  <FormControl style={{maxWidth:"50px"}} as="button" onClick={onChangeSortType}><FaIcons.FaSortAmountDownAlt/></FormControl>
                </Col>          
              </Row>
              <Row>
                <JobsList handleClose={handleClose} onSelected={props.onSelected} listOfJobs = {listOfJobs} mode = {1}/>      
              </Row>
            </Container>

          </Modal.Body>
        </Modal>
      </>
    );
  }

  
  export default SearchJob;